<template>
<drawer :opened.sync="opened" @close="onCloseBtnClick">
  <template #header>人工审核</template>

  <template #toolbar>
    <audit-operator-btn-group
      ref="auditOperator"
      :model="model"
    />
  </template>

  <template #body>
    <section class="data-list">
      <section
        v-for="factorData in factorDataList"
        :key="factorData.id"
        class="data-item"
      >
        <section class="data-item-header">
          <span>{{factorData.name}}</span>
          <el-link
            v-if="relatedFactorMap[factorData.id]"
            type="warning"
            style="float:right;"
            @click="onRelatedBtnClick(factorData)"
          >相关性分析</el-link>
        </section>
        <section class="data-item-body">
          <el-table
            ref="table"
            :data="factorData.list"
            border
            stripe
            highlight-current-row
            header-row-class-name="custom-table-header"
            class="custom-table no-inner-border"
            style="width: 100%"
          >
            <el-table-column label="序号" width="50">
              <template slot-scope="{$index}">{{$index + 1}}</template>
            </el-table-column>
            <el-table-column label="数据时间" width="170">
              <template slot-scope="{row}">{{row.dataTime.format('YYYY-MM-DD HH时')}}</template>
            </el-table-column>
            <el-table-column label="监测值">
              <template slot-scope="{row}"><span :style="Number.isFinite(row.originalValue) ? 'color: #67C23A;text-decoration: underline;' : ''">{{Number.isFinite(row.value) ? `${row.value}${factorData.unit}` : '--'}}</span></template>
            </el-table-column>
            <el-table-column label="机审状态" align="center">
              <template slot-scope="{row}">
                <el-tag
                  :type="row.autoFlag === 'N' ? 'success' : 'warning'"
                  size="mini"
                >{{row.autoFlag === 'N' ? '有效' : (row.autoFlag ? row.autoFlag.split('|').map(autoFlag => auditRuleCategoryMap[autoFlag]).join(',') : '')}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="人工审核状态" align="center">
              <template slot-scope="{row}">
                <el-tag
                  v-if="row.auditFlag"
                  :type="row.auditFlag === 'N' ? 'primary' : (row.auditFlag === 'RESERVE' ? 'success' : 'warning')"
                  size="mini"
                >{{row.auditFlag === 'N' ? '有效' : auditRuleCategoryMap[row.auditFlag]}}</el-tag>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column label="理由" prop="auditComment" align="center" />
          </el-table>
        </section>
      </section>
    </section>
  </template>

  <template #footer>
    <el-button
      :disabled="model.comment === ''"
      type="orange"
      class="btn save-btn"
      @click="onSaveBtnClick"
    >保存</el-button>
    <a class="cancel-btn btn" @click="onCloseBtnClick">关闭</a>
  </template>
</drawer>
</template>

<script>
import BaseStore from '../../../components/BaseStore'
import manualOperatorTypes from './manualOperatorTypes'

import {PROCESS_PANEL_SAVE, SHOW_PROCESS_PANEL, SHOW_RELATED_CHARTS_DIALOG} from './EventKeys'
import AuditOperatorBtnGroup from './AuditOperatorBtnGroup'

export default {
  name: 'ProcessPanel',
  extends: BaseStore,
  components: {AuditOperatorBtnGroup},
  props: {
    stage: {
      required: true,
      type: Number
    },
    siteDevice: {
      required: true
    },
    auditRuleCategories: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      opened: false,
      model: {
        operatorType: '',
        comment: ''
      },
      auditDataList: [],
      currentUnitKey: ''
    }
  },
  computed: {
    manualOperatorTypes: () => manualOperatorTypes,
    auditCategories () {
      return [...this.auditRuleCategories, {
        id: 'DERROR',
        name: '仪器异常',
        flags: ['DERROR'],
        themeType: 'error'
      }, {
        id: 'QERROR',
        name: '质控异常',
        flags: ['QERROR'],
        themeType: 'error'
      }, ...this.manualOperatorTypes]
    },
    auditRuleCategoryMap () {
      return this.auditCategories.reduce((map, auditRuleCategory) => {
        return auditRuleCategory.flags.reduce((map, flag) => {
          map[flag] = auditRuleCategory.name
          return map
        }, map)
      }, {})
    },
    factorDataList () {
      let {factorMap, currentUnitKey} = this
      let auditDataMap = this.auditDataList.reduce((map, auditData) => {
        let {factorId} = auditData
        let factorData = map[factorId]

        if (!factorData) {
          let factor = factorMap[factorId]

          factorData = map[factorId] = {
            id: factorId,
            name: factor.name,
            unit: factor[currentUnitKey],
            list: []
          }
        }

        factorData.list.push(auditData)

        return map
      }, {})

      let list = Object.values(auditDataMap)

      list.forEach(item => {
        item.list.sort((a, b) => a.dataTime.getTime() - b.dataTime.getTime())
      })

      return list
    }
  },
  methods: {
    open () {
      let refAuditOperator = this.$refs.auditOperator
      refAuditOperator && refAuditOperator.clear()
      this.opened = true
    },
    close () {
      this.opened = false
    },
    onCloseBtnClick () {
      this.close()
    },
    onSaveBtnClick () {
      let {model} = this
      this.changeLoadStatus(true)

      this.$api.Audit.updateAuditFlag({
        siteDeviceId: this.siteDevice.id,
        auditFlag: model.operatorType,
        auditComment: model.comment,
        ids: this.auditDataList.map(({id}) => id)
      }).then(data => {
        if (data) {
          this.$eventBus.emit(PROCESS_PANEL_SAVE)
          this.close()
        }
      }).catch(console.error).finally(() => {
        this.changeLoadStatus(false)
      })
    },
    onShowProcessPanel (data) {
      let {auditDataList, unit} = data
      this.open()
      this.currentUnitKey = unit
      this.auditDataList = auditDataList
    },
    onRelatedBtnClick (factorData) {
      this.$eventBus.emit(SHOW_RELATED_CHARTS_DIALOG, factorData)
    }
  },
  created () {
    this.$eventBus.on(SHOW_PROCESS_PANEL, this.onShowProcessPanel)
  },
  beforeDestroy () {
    this.$eventBus.off(SHOW_PROCESS_PANEL, this.onShowProcessPanel)
  }
}
</script>

<style lang="scss" scoped>
.data-list {
  padding: .7em 0;

  > .data-item {

    & + .data-item {
      margin-top: 1.5em;
    }

    > .data-item-header {
      width: 100%;
      line-height: 1.8em;
      padding: 0 10px;
      background: linear-gradient(to right, #fbc15a 0%, #FFF 100%);
      color: #ffffff;
      font-weight: 600;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/02Data-Audit/01Manual/ProcessPanel.vue